<template>
    <div v-if="facet.name" class="card pt-4" :class="facet.cssClass">
        <div v-if="!desktopFilter" class="h3 title py-0">
            {{ facetName }}
        </div>
        <div v-if="facet.type === 'price'">
            <item-filter-price></item-filter-price>
        </div>
		<div v-else-if="desktopFilter && facet.type !== 'price'" class="d-flex">
            <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle"
                        type="button"
                        :id="'dropdownMenuButton-' + facet.id"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                    {{ facetName }}
                </button>
                <div class="dropdown-menu"
                     :aria-labelledby="'dropdownMenuButton-' + facet.id">
                    <span v-for="value in facet.values"
                          class="dropdown-item"
                          :class="[
                              value.cssClass,
                              {'item-filter__value--active': isSelected(value.id), 'item-filter__value--disabled': isLoading || value.count <= 0}
                          ]"
                          :key="value.id"
                          @click="updateFacet(value)">
                        {{ value.name }}
                    </span>
                </div>
            </div>
            <template v-for="value in facet.values">
                <div v-if="isSelected(value.id)"
                      class="item-filter__selected"
                      :class="value.cssClass"
                      :key="value.id"
                      @click="updateFacet(value)">
					<svg fill="currentColor" width="20" height="20">
						<use xlink:href="#cancel" />
					</svg>
					<span>
						{{ value.name }}
					</span>
                </div>
            </template>
		</div>
        <div v-else class="form-check-wrapper" v-for="value in facets" :key="value.id" :class="{'active': value.selected === true}">
			<svg v-if="value.selected === true" class="mobile-nav__chevron" fill="currentColor" width="13" height="13">
				<use xlink:href="#cancel" />
			</svg>
            <div class="form-check mb-0 pl-0">
                <input :id="'option-' + value.id + '-' + _uid" class="form-check-input d-none" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
                <label :for="'option-' + value.id + '-' + _uid" class="form-check-label" :class="[paddingClasses, isSelected(value.id) ? 'bg-appearance' : '', 'option-' + value.id]" :style="paddingInlineStyles">
                    <div class="d-flex">
                        <span class="flex-grow-1">{{ value.name }}</span>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "ceres/app/components/itemList/filter/ItemFilterPrice.vue";

export default {

    name: "item-filter",

    components: {
        ItemFilterPrice
    },

    props: {
		desktopFilter: Boolean,
        facet: {
            type: Object
        },
        paddingClasses: {
            type: String,
            default: null
        },
        paddingInlineStyles: {
            type: String,
            default: null
        }
    },

    computed: {
        facets() {
            return this.facet.values;
        },
        facetName() {
            if(this.facet.translationKey && this.facet.translationKey.length > 0) {
                return this.$translate("Ceres::Template." + this.facet.translationKey);
            }

            return this.facet.name;
        },
        ...mapState({
            selectedFacets: state => state.itemList.selectedFacets,
            isLoading: state => state.itemList.isLoading
        })
    },

    methods: {
        updateFacet(facetValue) {

            const toolbarElements = document.getElementsByClassName("widget-toolbar");

            for(const toolbarElement of toolbarElements) {
                if (toolbarElement.contains(this.$vnode.elm)) {
                    window.localStorage.setItem("openFilterToolbar", true);
                }
            }

            this.$store.dispatch("selectFacet", { facetValue });
        },
        isSelected(facetValueId) {
            return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
        }
    }
}
</script>
